import axios from 'axios'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import Spinner from 'components/loader/Spinner'
import DefaultSelect from 'components/formElements/DefaultSelect'
import Tooltip from 'components/tooltip/Tooltip'
import ApprovalContent from '../components/modalContent/ApprovalContent'
import { useState, useEffect, useRef, useMemo } from 'react'
import { useRequest } from 'hooks/useRequest'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { useDispatch, useSelector } from 'react-redux'
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { setProjects } from 'redux/features/projects/projectsSlice'
import { Dropdown } from 'primereact/dropdown';
import { getProjectDisplayLabel } from '../utils/Constants'
import { useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { Button } from 'primereact/button';
import moment from 'moment'
import { getPermission } from "../utils/Auth";
import { Dialog } from "primereact/dialog";
import {closeApprovalModal, openApprovalModal} from "../redux/features/general/generalSlice";
import useWindowSize from "../hooks/useWindowSize";
import DefaultButton from 'components/formElements/Button'

const WeeklyPlanDetail = () => {
    const [getProjects] = useRequest()
    const [request] = useRequest()
    const [getDevelopersLoading] = useRequest()
    const dispatch = useDispatch()
    const { general } = useSelector((state) => state)
    const { approvalModal } = general
    const { width } = useWindowSize()
    const [newarray, setNewarr] = useState();
    const [planProjectList, setPlanProjectList] = useState(null);
    const [selectedId, setSelectedId] = useState();
    const [allWeekProjectDialog, setAllWeekProjectDialog] = useState({visible: false, developerId: null, project: null});
    const [day1, setDay1] = useState();
    const [day2, setDay2] = useState();
    const [day3, setDay3] = useState();
    const [day4, setDay4] = useState();
    const [day5, setDay5] = useState();


    const [filterOptions, setFilterOptions] = useState({ department: [] })
    const [departments, setDepartments] = useState([])
    const [selectedPmId, setSelectedPmId] = useState(null)
    const [projectManagers, setProjectManagers] = useState([])

    const location = useLocation();

    // Login olmadan link ile açıldığında (public mod)
    const auth = JSON.parse(localStorage.getItem('auth'))
    const isPublic = !auth?.token

    // Görüntüleme modu: yetkisi yoksa veya public modda sadece view (düzenleme yok)
    const canUpdate = !isPublic && getPermission('WeeklyPlan.update')
    const isViewOnly = isPublic || !canUpdate

    const [planDataLoading, setPlanDataLoading] = useState(!!isPublic)
    const [planLoadError, setPlanLoadError] = useState(null)

    const { projects } = useSelector((state) => state)
    const { projectsData } = projects

    const pdfRef = useRef();
    const dataTableRef = useRef();

    const departmentBgColors = {
        2: 'bg-backend',
        3: 'bg-frontend',
        4: 'bg-sharepoint',
        5: 'bg-test',
        6: 'bg-mobile',
        7: 'bg-design',
        8: 'bg-html',
        10: 'bg-odito'
    }

    // Plan API'si projeleri müşteri/şirket alanları olmadan döndürüyor, etiket için store'daki tam kayıt kullanılıyor
    const projectDropdown = useMemo(() => {
        const pmFiltered = selectedPmId != null && planProjectList
        const source = (pmFiltered ? planProjectList : projectsData) || planProjectList || []
        return source.map((p) => ({
            label: getProjectDisplayLabel(projectsData?.find((pd) => pd.id === p.id) || p),
            value: p.id
        }))
    }, [selectedPmId, planProjectList, projectsData])

    const getWeekYearFromPath = () => {
        const urlParsed = location.pathname.replace(/\/\s*$/, '').split('/')[2]
        if (!urlParsed) return null
        const parsed = urlParsed.split('-')
        if (!parsed[0] || !parsed[1]) return null
        return { week: parsed[0], year: parsed[1] }
    }

    const buildPlanParams = (week, year) => {
        const params = { week, year }
        if (selectedPmId != null) {
            params.pmId = selectedPmId
        }
        return params
    }

    const applyPlanResult = (result) => {
        if (!result) return
        setNewarr(result.getAllWeeklyPlanDtos)
        setPlanProjectList(Array.isArray(result.projectList) ? result.projectList : null)
    }

    useEffect(() => {
        if (isPublic) return
        getProjects('/Project/GetAllProjects', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                dispatch(setProjects(res.data.result))
            }
        })
        request('/Developer/GetDepartments', {
            method: 'GET',
        }).then((res) => {
            if (res.data.ok) {
                setDepartments(res.data.result.filter(d => d.includeInWeeklyPlan).map((s) => ({ label: s.name, value: s.id })))
            }
        })
        request('/WeeklyPlan/GetProjectManagers', {
            method: 'GET',
        }).then((res) => {
            if (res.data?.result) {
                setProjectManagers((res.data.result || []).map((pm) => ({ label: pm.name, value: pm.id })))
            }
        })
    }, [isPublic])

    // Hafta başlık tarihlerini URL'deki hafta/yıldan hesapla (API yanlış tarih dönse bile 23, 24, 25... doğru görünsün)
    const setDayLabelsFromWeekYear = (week, year) => {
        const w = parseInt(week, 10)
        const y = parseInt(year, 10)
        if (isNaN(w) || isNaN(y)) return
        const monday = moment().year(y).isoWeek(w).startOf('isoWeek')
        setDay1(monday.clone().add(0, 'days').format('DD.MM'))
        setDay2(monday.clone().add(1, 'days').format('DD.MM'))
        setDay3(monday.clone().add(2, 'days').format('DD.MM'))
        setDay4(monday.clone().add(3, 'days').format('DD.MM'))
        setDay5(monday.clone().add(4, 'days').format('DD.MM'))
    }

    const fetchWeeklyPlan = (week, year) => {
        return request('/WeeklyPlan/GetAllWeeklyPlanByWeekNumber', {
            method: 'GET',
            params: buildPlanParams(week, year)
        }).then((res) => {
            applyPlanResult(res.data?.result)
            return res
        })
    }

    useEffect(() => {
        const weekYear = getWeekYearFromPath()
        if (!weekYear) return
        const { week, year } = weekYear

        setDayLabelsFromWeekYear(week, year)

        if (isPublic) {
            setPlanDataLoading(true)
            setPlanLoadError(null)
            // eslint-disable-next-line no-undef
            const baseURL = process.env.REACT_APP_API_ENDPOINT
            axios.get(`${baseURL}/WeeklyPlan/GetAllWeeklyPlanByWeekNumber`, {
                params: buildPlanParams(week, year)
            }).then((res) => {
                const result = res.data?.result
                const dtos = result?.getAllWeeklyPlanDtos
                if (dtos?.length) {
                    setNewarr(dtos)
                }
                if (Array.isArray(result?.projectList)) {
                    setPlanProjectList(result.projectList)
                }
                setPlanLoadError(null)
            }).catch((err) => {
                setPlanLoadError(err.response?.status === 401 ? 'Görüntülemek için giriş yapmanız gerekiyor.' : 'Plan yüklenemedi.')
                setNewarr([])
            }).finally(() => setPlanDataLoading(false))
            return
        }

        fetchWeeklyPlan(week, year)
    }, [location.pathname, isPublic, selectedPmId])


    const handleDepartment = (e) => {
        setFilterOptions((prev) => ({
            ...prev,
            ['department']: e && e != undefined ? e : e.length > 0 && e,
        }))
    }

    const handlePmChange = (e) => {
        setSelectedPmId(e?.value ?? null)
    }



    const headerGroup = (
        <ColumnGroup>
            <Row>
                <Column header="RESOURCE NAME" rowSpan={3} />
            </Row>
            <Row>
                <Column header={day1 + " PAZARTESI"} colSpan={2} alignHeader={'center'} style={{ border: "2px solid #c9c9c9" }} />
                <Column header={day2 + " SALI"} colSpan={2} alignHeader={'center'} style={{ border: "2px solid #c9c9c9" }} />
                <Column header={day3 + " ÇARŞAMBA"} colSpan={2} alignHeader={'center'} style={{ border: "2px solid #c9c9c9" }} />
                <Column header={day4 + " PERŞEMBE"} colSpan={2} alignHeader={'center'} style={{ border: "2px solid #c9c9c9" }} />
                <Column header={day5 + " CUMA"} colSpan={2} alignHeader={'center'} style={{ border: "2px solid #c9c9c9" }} />

            </Row>
            <Row>
                <Column header="Öğleden Önce" field="status" style={{ border: "2px solid #c9c9c9" }} />
                <Column header="Öğleden Sonra" field="status" style={{ border: "2px solid #c9c9c9" }} />
                <Column header="Öğleden Önce" field="status" style={{ border: "2px solid #c9c9c9" }} />
                <Column header="Öğleden Sonra" field="status" style={{ border: "2px solid #c9c9c9" }} />
                <Column header="Öğleden Önce" field="status" style={{ border: "2px solid #c9c9c9" }} />
                <Column header="Öğleden Sonra" field="status" style={{ border: "2px solid #c9c9c9" }} />
                <Column header="Öğleden Önce" field="status" style={{ border: "2px solid #c9c9c9" }} />
                <Column header="Öğleden Sonra" field="status" style={{ border: "2px solid #c9c9c9" }} />
                <Column header="Öğleden Önce" field="status" style={{ border: "2px solid #c9c9c9" }} />
                <Column header="Öğleden Sonra" field="status" style={{ border: "2px solid #c9c9c9" }} />
            </Row>
        </ColumnGroup>
    );

    const debounce = (func, delay) => {
        let timeoutId;
        return function(...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func(...args), delay);
        };
    };

    const onCellEditComplete = (e) => {
        let isProjectId = Number.isInteger(e)
        request('/WeeklyPlan/UpdateWeeklyPlan', {
            method: 'POST',
            data: {
                id: selectedId,
                status: isProjectId ? null : e,
                projectId: isProjectId ? e : null
            }
        }).then((res) => {
            if (res?.data?.result) {
                const weekYear = getWeekYearFromPath()
                if (!weekYear) return
                fetchWeeklyPlan(weekYear.week, weekYear.year).then(() => {
                    dataTableRef.current.closeEditingCell()
                })
            }
        })
    }

    const onCellEditFilter = debounce((options, e) => {
        if (!e.target.className.includes('p-dropdown-label')){
            return;
        }

        options.editorCallback(e.target.value);

        setTimeout(() => {
            e.target.focus();
        }, 10);
    }, 300);

    // Çalışanın çıkış tarihinden sonraki günlere atama yapılamaz (çıkış gününe planlama yapılabilir)
    const isCellAfterExitDate = (cellData, rowData) => {
        const developer = rowData?.[0]?.developer
        if (!developer?.endDate || !cellData?.date) return false
        const cellDay = moment(cellData.date).startOf('day')
        const exitDay = moment(developer.endDate).startOf('day')
        return cellDay.isAfter(exitDay) // sadece çıkış gününden sonrası engelli
    }

    const statusEditor = (options, index) => {
        let cellData = options?.rowData[index]
        let leave = cellData?.isLeave
        const rowData = options?.rowData
        const afterExitDate = isCellAfterExitDate(cellData, rowData)

        if (leave)
        {
            return (
                <div className='text-sm cellSetTransparent bg-leave'>
                    {cellData?.status}
                </div>
            )
        }

        if (afterExitDate) {
            return (
                <div className='text-sm cellSetTransparent bg-secondary text-white' title='Çıkış tarihinden sonra, atama yapılamaz'>
                    {cellData?.projectId ? cellData?.projectCustomerName + '/' + cellData?.projectName : cellData?.status || '—'}
                </div>
            )
        }

        setSelectedId(cellData?.id)

        return <Dropdown value={options.value || cellData?.projectId || cellData?.status}
                         onChange={e => e.originalEvent && onCellEditComplete(e.value)}
                         onInput={e => onCellEditFilter(options, e)}
                         options={projectDropdown}
                         optionLabel="label"
                         optionValue='value'
                         showClear
                         filter
                         filterLocale="tr"
                         editable
                         filterInputAutoFocus={false}
                         className={'w-100'}/>
    };

    const filteredDevs = newarray?.filter((d) => {
        const keys = Object.keys(filterOptions)
        let rt = [true]
        if (keys.length > 0) {
            keys.forEach((k) => {
                if (filterOptions[k] != null) {
                    if (k == 'department') {
                        filterOptions.department.length > 0 &&
                            rt.push(d[0].developer.department
                                .name.split(',').some(r => filterOptions[k].map((e) => e.label).indexOf(r) >= 0))

                    }
                }
            })
        }
        return rt.every((r) => r)
    })


    const dowloadPDF = () => {
        const input = pdfRef.current;
        const element = input.getElementsByClassName('p-datatable-wrapper')[0];
        const options = {
            windowWidth: 1366,
        }
        html2canvas(element,options).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', [(canvas.height * 279) / canvas.width, 279], true);
            const imgProps= pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save(`Nuevo Weekly Plan ${day1.replace('.', '-')}.pdf`)
        })
    }

    const handleCopyFromPreviousWeeklyPlan = () => {
        let urlParsed = location.pathname.replace(/\/\s*$/, '').split('/')[2]
        let urlParams = urlParsed.split('-');

        dispatch(openApprovalModal({
            open: true,
            content: 'Geçmiş hafta planını kopyalamak istediğinize emin misiniz?',
            url: '/WeeklyPlan/CopyFromPreviousWeeklyPlan',
            method: 'POST',
            params: {
                week: urlParams[0],
                year: urlParams[1]
            }
        }));
    }

    const handleSubmitApproval = () => {
        if (!approvalModal.url) {
            handleCloseApprovalModal()
            return;
        }

        request(approvalModal.url, {
            method: approvalModal.method || 'POST',
            data: approvalModal.data,
            params: approvalModal.params
        }).then((res) => {
            if (res?.data?.result) {
                const weekYear = getWeekYearFromPath()
                if (weekYear) {
                    // Kopyalama sonrası seçili pmId ile yeniden çek
                    fetchWeeklyPlan(weekYear.week, weekYear.year)
                } else {
                    applyPlanResult(res.data.result)
                }
            }

            handleCloseApprovalModal()
        })
    }

    const handleCloseApprovalModal = () => {
        dispatch(closeApprovalModal())
    }

    const handleAllWeekProject = () => {
        let project = allWeekProjectDialog.project || null
        let isProjectId = Number.isInteger(project)

        const weekYear = getWeekYearFromPath()
        if (!weekYear) return

        let rowData = newarray?.find((d) => d[0].developerId == allWeekProjectDialog.developerId) || []

        let promises = rowData.map((r) => {
            if ((project && (r.projectId || r.status))
                || (!project && !r.projectId && !r.status)
                || r.isLeave
                || isCellAfterExitDate(r, rowData)) {
                return Promise.resolve()
            }

            return request('/WeeklyPlan/UpdateWeeklyPlan', {
                method: 'POST',
                data: {
                    id: r.id,
                    status: isProjectId ? null : project,
                    projectId: isProjectId ? project : null
                }
            })
        })

        Promise.all(promises).then(() => {
            fetchWeeklyPlan(weekYear.week, weekYear.year).then((res) => {
                if (res?.data?.result) {
                    closeAllWeekProjectDialog()
                }
            })
        })
    }

    const openAllWeekProjectDialog = (developerId) => {
        setAllWeekProjectDialog({visible: true, developerId: developerId, project: null})
    }

    const closeAllWeekProjectDialog = () => {
        setAllWeekProjectDialog({visible: false, developerId: null, project: null})
    }

    const showTable = isPublic ? (!planDataLoading && !planLoadError) : getDevelopersLoading
    const showSpinner = isPublic ? planDataLoading : !getDevelopersLoading

    return (
        <AnimatedSpan className='page-container d-flex flex-column'>
            {planLoadError && (
                <div className='alert alert-warning text-center'>
                    {planLoadError}
                    <br />
                    <a href='/login'>Giriş sayfasına git</a>
                </div>
            )}
            {showSpinner && (
                <div className='d-flex w-100 justify-content-center'>
                    <Spinner size={3} />
                </div>
            )}
            {showTable && (
                <div ref={pdfRef} className='mb-5'>
                    <DataTable
                        ref={dataTableRef}
                        className='col-md-12 p-1'
                        emptyMessage='Hiç Kayıt Bulunamadı'
                        size='small'
                        responsiveLayout='stack'
                        headerColumnGroup={headerGroup}
                        dataKey='id'
                        editMode={isViewOnly ? undefined : "cell"}
                        header={() => (
                            <div className='d-flex justify-content-between gap-3 flex-wrap align-items-center'>
                                {!isPublic && (
                                    <div className='d-flex gap-3 flex-wrap flex-1'>
                                        <div className='col-md-3'>
                                            <DefaultSelect
                                                isMulti={true}
                                                name='department'
                                                placeholder='Departmanlar'
                                                value={filterOptions.department}
                                                selectOptions={departments}
                                                handleChange={(e) => handleDepartment(e, 'department')}
                                            />
                                        </div>
                                        <div className='col-md-3'>
                                            <DefaultSelect
                                                isClearable
                                                isSearchable
                                                name='pm'
                                                placeholder="Tüm PM'ler"
                                                value={projectManagers.find((pm) => pm.value === selectedPmId) || null}
                                                selectOptions={projectManagers}
                                                handleChange={handlePmChange}
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className='filters-right d-flex align-items-center gap-2'>
                                    {isViewOnly && (
                                        <span className='badge bg-secondary text-white py-2'>
                                            Sadece görüntüleme
                                        </span>
                                    )}
                                    {canUpdate && (
                                        <Button
                                            onClick={handleCopyFromPreviousWeeklyPlan}
                                            className='btn-primary mr-3'
                                            label={width <= 936 ? '' : 'Önceki Haftayı Kopyala'}
                                            title={'Önceki Haftayı Kopyala'}
                                            icon="pi pi-history"
                                        />
                                    )}
                                    {!isPublic && (
                                        <Button
                                            icon="pi pi-file-pdf"
                                            className='btn-success btn-rounded'
                                            onClick={dowloadPDF}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                        rowClassName={`cursor-pointer table-hover `}
                        value={filteredDevs}
                    >
                        <Column
                            headerClassName='text-bold bg-primary text-default'
                            className='text-semi-bold text-sm'
                            style={{ width: 'auto', position: 'relative' }}
                            field='isBeforeMidday'
                            header='Resource Name'
                            sortable='true'
                            body={(rowData) => {
                                const bgColor = departmentBgColors[rowData[0].developer.departmentId] || 'bg-white'

                                return (
                                    <div className={`text-sm cellSetTransparent justify-content-between ${bgColor}`}>
                                        {rowData[0].developer.fullName}
                                        {!isViewOnly && (
                                            <Button
                                                data-html2canvas-ignore="true"
                                                icon="pi pi-file-import"
                                                className='p-button-sm p-button-rounded p-button-secondary'
                                                style={{width: '2rem', height: '2rem', padding: '2px 4px 2px 2px', margin: '0 5px'}}
                                                tooltip={'Tüm Haftayı Planla'}
                                                onClick={() => openAllWeekProjectDialog(rowData[0].developerId)}
                                            />
                                        )}
                                    </div>
                                )
                            }}
                        />
                        <Column
                            field='status'
                            header='Pazartesi Öğleden Önce'
                            className='border-black'
                            sortable='true'
                            body={(rowData, i) => {
                                const cellData = rowData[0]
                                const afterExitDate = isCellAfterExitDate(cellData, rowData)
                                const status = cellData?.isLeave ? cellData?.status : (cellData?.projectId ? cellData?.projectCustomerName + "/" + cellData?.projectName : cellData?.status)
                                const odd = i.rowIndex % 2 == 1;
                                return (
                                    <div className={`text-sm cellSetTransparent  ${afterExitDate ? 'bg-secondary text-white' : cellData?.isLeave ? 'bg-leave' : odd ? 'bg-light-green' : 'bg-green'} `} title={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : undefined}>
                                        <Tooltip textClass='bottom' text={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : status} >
                                            <div className=' text-elipsisPlan white-space-no'>{status} </div>
                                        </Tooltip>
                                    </div>
                                )
                            }}
                            editor={!isViewOnly ? (options) => statusEditor(options, 0) : undefined}
                            cellEditValidator={!isViewOnly ? (e) => !e.originalEvent?.target?.closest('.p-dropdown-header') : undefined}
                            onCellEditComplete={!isViewOnly ? (e => e.newValue && onCellEditComplete(e.newValue)) : undefined}
                        />
                        <Column
                            field='status'
                            header='Pazartesi Öğleden Sonra'
                            className='border-black'
                            sortable='true'
                            body={(rowData, i) => {
                                const cellData = rowData[1]
                                const afterExitDate = isCellAfterExitDate(cellData, rowData)
                                const status = cellData?.isLeave ? cellData?.status : (cellData?.projectId ? cellData?.projectCustomerName + "/" + cellData?.projectName : cellData?.status)
                                const odd = i.rowIndex % 2 == 1;
                                return (
                                    <div className={`text-sm cellSetTransparent  ${afterExitDate ? 'bg-secondary text-white' : cellData?.isLeave ? 'bg-leave' : odd ? 'bg-light-green' : 'bg-green'} `} title={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : undefined}>
                                        <Tooltip textClass='bottom' text={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : status} >
                                            <div className=' text-elipsisPlan white-space-no'>{status} </div>
                                        </Tooltip>
                                    </div>
                                )
                            }}
                            editor={!isViewOnly ? (options) => statusEditor(options, 1) : undefined}
                            cellEditValidator={!isViewOnly ? (e) => !e.originalEvent?.target?.closest('.p-dropdown-header') : undefined}
                            onCellEditComplete={!isViewOnly ? (e => e.newValue && onCellEditComplete(e.newValue)) : undefined}
                        />

                        <Column
                            field='status'
                            header='Salı Öğleden Önce'
                            sortable='true'
                            className='border-black'
                            body={(rowData, i) => {
                                const cellData = rowData[2]
                                const afterExitDate = isCellAfterExitDate(cellData, rowData)
                                const status = cellData?.isLeave ? cellData?.status : (cellData?.projectId ? cellData?.projectCustomerName + "/" + cellData?.projectName : cellData?.status)
                                const odd = i.rowIndex % 2 == 1;
                                return (
                                    <div className={`text-sm cellSetTransparent ${afterExitDate ? 'bg-secondary text-white' : cellData?.isLeave ? 'bg-leave' : ''} ${!afterExitDate && !cellData?.isLeave && (odd ? 'bg-light-blue' : 'bg-blue')}`} title={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : undefined}>
                                        <Tooltip textClass='bottom' text={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : status} >
                                            <div className=' text-elipsisPlan white-space-no'>{status} </div>
                                        </Tooltip>
                                    </div>
                                )
                            }}
                            editor={!isViewOnly ? (options) => statusEditor(options, 2) : undefined}
                            cellEditValidator={!isViewOnly ? (e) => !e.originalEvent?.target?.closest('.p-dropdown-header') : undefined}
                            onCellEditComplete={!isViewOnly ? (e => e.newValue && onCellEditComplete(e.newValue)) : undefined}
                        />
                        <Column
                            field='status'
                            header='Salı Öğleden Sonra'
                            sortable='true'
                            className='border-black'
                            body={(rowData, i) => {
                                const cellData = rowData[3]
                                const afterExitDate = isCellAfterExitDate(cellData, rowData)
                                const status = cellData?.isLeave ? cellData?.status : (cellData?.projectId ? cellData?.projectCustomerName + "/" + cellData?.projectName : cellData?.status)
                                const odd = i.rowIndex % 2 == 1;
                                return (
                                    <div className={`text-sm cellSetTransparent  ${afterExitDate ? 'bg-secondary text-white' : cellData?.isLeave ? 'bg-leave' : odd ? 'bg-light-blue' : 'bg-blue'} `} title={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : undefined}>
                                        <Tooltip textClass='bottom' text={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : status} >
                                            <div className=' text-elipsisPlan white-space-no'>{status} </div>
                                        </Tooltip>
                                    </div>
                                )
                            }}
                            editor={!isViewOnly ? (options) => statusEditor(options, 3) : undefined}
                            cellEditValidator={!isViewOnly ? (e) => !e.originalEvent?.target?.closest('.p-dropdown-header') : undefined}
                            onCellEditComplete={!isViewOnly ? (e => e.newValue && onCellEditComplete(e.newValue)) : undefined}
                        />
                        <Column
                            field='status'
                            header='Çarşamba Öğleden Önce'
                            sortable='true'
                            className='border-black'
                            body={(rowData, i) => {
                                const cellData = rowData[4]
                                const afterExitDate = isCellAfterExitDate(cellData, rowData)
                                const status = cellData?.isLeave ? cellData?.status : (cellData?.projectId ? cellData?.projectCustomerName + "/" + cellData?.projectName : cellData?.status)
                                const odd = i.rowIndex % 2 == 1;
                                return (
                                    <div className={`text-sm cellSetTransparent  ${afterExitDate ? 'bg-secondary text-white' : cellData?.isLeave ? 'bg-leave' : odd ? 'bg-light-green' : 'bg-green'} `} title={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : undefined}>
                                        <Tooltip textClass='bottom' text={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : status} >
                                            <div className=' text-elipsisPlan white-space-no'>{status} </div>
                                        </Tooltip>
                                    </div>
                                )
                            }}
                            editor={!isViewOnly ? (options) => statusEditor(options, 4) : undefined}
                            cellEditValidator={!isViewOnly ? (e) => !e.originalEvent?.target?.closest('.p-dropdown-header') : undefined}
                            onCellEditComplete={!isViewOnly ? (e => e.newValue && onCellEditComplete(e.newValue)) : undefined}
                        />
                        <Column
                            field='status'
                            header='Çarşamba Öğleden Sonra'
                            sortable='true'
                            className='border-black'
                            body={(rowData, i) => {
                                const cellData = rowData[5]
                                const afterExitDate = isCellAfterExitDate(cellData, rowData)
                                const status = cellData?.isLeave ? cellData?.status : (cellData?.projectId ? cellData?.projectCustomerName + "/" + cellData?.projectName : cellData?.status)
                                const odd = i.rowIndex % 2 == 1;
                                return (
                                    <div className={`text-sm cellSetTransparent  ${afterExitDate ? 'bg-secondary text-white' : cellData?.isLeave ? 'bg-leave' : odd ? 'bg-light-green' : 'bg-green'} `} title={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : undefined}>
                                        <Tooltip textClass='bottom' text={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : status} >
                                            <div className=' text-elipsisPlan white-space-no'>{status} </div>
                                        </Tooltip>
                                    </div>
                                )
                            }}
                            editor={!isViewOnly ? (options) => statusEditor(options, 5) : undefined}
                            cellEditValidator={!isViewOnly ? (e) => !e.originalEvent?.target?.closest('.p-dropdown-header') : undefined}
                            onCellEditComplete={!isViewOnly ? (e => e.newValue && onCellEditComplete(e.newValue)) : undefined}
                        />
                        <Column
                            field='status'
                            header='Perşembe Öğleden Önce'
                            sortable='true'
                            className='border-black'
                            body={(rowData, i) => {
                                const cellData = rowData[6]
                                const afterExitDate = isCellAfterExitDate(cellData, rowData)
                                const status = cellData?.isLeave ? cellData?.status : (cellData?.projectId ? cellData?.projectCustomerName + "/" + cellData?.projectName : cellData?.status)
                                const odd = i.rowIndex % 2 == 1;
                                return (
                                    <div className={`text-sm cellSetTransparent  ${afterExitDate ? 'bg-secondary text-white' : cellData?.isLeave ? 'bg-leave' : odd ? 'bg-light-blue' : 'bg-blue'} `} title={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : undefined}>
                                        <Tooltip textClass='left' text={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : status} >
                                            <div className=' text-elipsisPlan white-space-no'>{status} </div>
                                        </Tooltip>
                                    </div>
                                )
                            }}
                            editor={!isViewOnly ? (options) => statusEditor(options, 6) : undefined}
                            cellEditValidator={!isViewOnly ? (e) => !e.originalEvent?.target?.closest('.p-dropdown-header') : undefined}
                            onCellEditComplete={!isViewOnly ? (e => e.newValue && onCellEditComplete(e.newValue)) : undefined}
                        />
                        <Column
                            field='status'
                            header='Perşembe Öğleden Sonra'
                            sortable='true'
                            className='border-black'
                            body={(rowData, i) => {
                                const cellData = rowData[7]
                                const afterExitDate = isCellAfterExitDate(cellData, rowData)
                                const status = cellData?.isLeave ? cellData?.status : (cellData?.projectId ? cellData?.projectCustomerName + "/" + cellData?.projectName : cellData?.status)
                                const odd = i.rowIndex % 2 == 1;
                                return (
                                    <div className={`text-sm cellSetTransparent  ${afterExitDate ? 'bg-secondary text-white' : cellData?.isLeave ? 'bg-leave' : odd ? 'bg-light-blue' : 'bg-blue'} `} title={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : undefined}>
                                        <Tooltip textClass='left' text={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : status} >
                                            <div className=' text-elipsisPlan white-space-no'>{status} </div>
                                        </Tooltip>
                                    </div>
                                )
                            }}
                            editor={!isViewOnly ? (options) => statusEditor(options, 7) : undefined}
                            cellEditValidator={!isViewOnly ? (e) => !e.originalEvent?.target?.closest('.p-dropdown-header') : undefined}
                            onCellEditComplete={!isViewOnly ? (e => e.newValue && onCellEditComplete(e.newValue)) : undefined}
                        />
                        <Column
                            field='status'
                            header='Cuma Öğleden Önce'
                            sortable='true'
                            className='border-black'
                            body={(rowData, i) => {
                                const cellData = rowData[8]
                                const afterExitDate = isCellAfterExitDate(cellData, rowData)
                                const status = cellData?.isLeave ? cellData?.status : (cellData?.projectId ? cellData?.projectCustomerName + "/" + cellData?.projectName : cellData?.status)
                                const odd = i.rowIndex % 2 == 1;
                                return (
                                    <div className={`text-sm cellSetTransparent  ${afterExitDate ? 'bg-secondary text-white' : cellData?.isLeave ? 'bg-leave' : odd ? 'bg-light-green' : 'bg-green'} `} title={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : undefined}>
                                        <Tooltip textClass='left' text={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : status} >
                                            <div className=' text-elipsisPlan white-space-no '>{status} </div>
                                        </Tooltip>
                                    </div>
                                )
                            }}
                            editor={!isViewOnly ? (options) => statusEditor(options, 8) : undefined}
                            cellEditValidator={!isViewOnly ? (e) => !e.originalEvent?.target?.closest('.p-dropdown-header') : undefined}
                            onCellEditComplete={!isViewOnly ? (e => e.newValue && onCellEditComplete(e.newValue)) : undefined}
                        />
                        <Column
                            field='status'
                            header='Cuma Öğleden Sonra'
                            sortable='true'
                            className='border-black'
                            body={(rowData, i) => {
                                const cellData = rowData[9]
                                const afterExitDate = isCellAfterExitDate(cellData, rowData)
                                const status = cellData?.isLeave ? cellData?.status : (cellData?.projectId ? cellData?.projectCustomerName + "/" + cellData?.projectName : cellData?.status)
                                const odd = i.rowIndex % 2 == 1;
                                return (
                                    <div className={`text-sm cellSetTransparent  ${afterExitDate ? 'bg-secondary text-white' : cellData?.isLeave ? 'bg-leave' : odd ? 'bg-light-green' : 'bg-green'} `} title={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : undefined}>
                                        <Tooltip textClass='left' text={afterExitDate ? 'Çıkış tarihinden sonra, atama yapılamaz' : status} >
                                            <div className=' text-elipsisPlan white-space-no'>{status} </div>
                                        </Tooltip>
                                    </div>
                                )
                            }}
                            editor={!isViewOnly ? (options) => statusEditor(options, 9) : undefined}
                            cellEditValidator={!isViewOnly ? (e) => !e.originalEvent?.target?.closest('.p-dropdown-header') : undefined}
                            onCellEditComplete={!isViewOnly ? (e => e.newValue && onCellEditComplete(e.newValue)) : undefined}
                        />

                    </DataTable>
                    <div className='mb-5' />
                </div>

            )}

            <Dialog draggable={false} visible={approvalModal.open} onHide={handleCloseApprovalModal}>
                <ApprovalContent handleClose={handleCloseApprovalModal} handleApproved={handleSubmitApproval} />
            </Dialog>

            <Dialog header="Haftalık Plan Belirle" visible={allWeekProjectDialog.visible} style={{width: '30rem'}} onHide={closeAllWeekProjectDialog}>
                <div className='w-100 d-flex flex-column gap-3'>
                    <div className="row text-center">
                        <div className="col-12">
                            <div className='form-control'>
                                <Dropdown value={allWeekProjectDialog.project}
                                          onChange={e => setAllWeekProjectDialog(prev => ({...prev, project: e.value}))}
                                          options={projectDropdown}
                                          optionLabel="label"
                                          optionValue='value'
                                          showClear
                                          filter
                                          editable
                                          filterInputAutoFocus={false}
                                          className={'w-100'}/>
                                <small className="block text-left">Boş bırakıldığında tüm hafta temizlenmektedir.</small>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center gap-3">
                        <DefaultButton handleClick={handleAllWeekProject} className='btn-success' title={'Onayla'} />
                        <DefaultButton handleClick={closeAllWeekProjectDialog} className='btn-danger-outline' title={'Vazgeç'} />
                    </div>
                </div>
            </Dialog>
        </AnimatedSpan>
    )
}


export default WeeklyPlanDetail
